import { DecoderHelpers } from '@headless-workspace/utils';
import { z } from 'zod';
import { FlagDTO, MediaDTO, ProductTypeDTO } from '../../../../src/client';
import { BrandDTO, PriceDTO } from '../../../../src/server';
import { ProductDetailPromotionDTO } from './ProductDetailPromotionDTO';
import { ProductDetailSetItemDTO } from './ProductDetailSetItemDTO';
import { ProductDetailVariantDTO } from './ProductDetailVariantDTO';
import { ProductDetailBannerDTO } from './banner';
import { BreadcrumbDTO } from './breadcrumb';

export const ProductDetailBaseDTO = z
    .object({
        id: z.string(),
        name: z.string().nullish(),
        vat: z.number().nullish(),
        currency: z.string().nullish(),
        description: z.string().nullish(),
        tips: z.string().nullish(),
        testResults: z.string().nullish(),
        compositions: z.string().nullish(),
        clinicalTests: z.string().nullish(),
        ingredients: z.string().nullish(),
        usage: z.string().nullish(),
        notes: z.string().nullish(),
        moreInformations: z.string().nullish(),
        kit: z
            .object({
                title: z.string().nullish(),
                description: z.string().nullish(),
            })
            .nullish(),
        rating: z.number().nullish(),
        reviewCount: z.number().nullish(),
        stockLevel: z.number().nullish(),
        barCode: z.string().nullish(),
        orderable: z.boolean().nullish(),
        offers: DecoderHelpers.defaultArray(z.unknown()), // FIXME: define OfferDTO, not defined in the API documentation
        products: z.array(ProductDetailSetItemDTO).nullish(),
        pricePerUnit: z.string().nullish(),
        type: ProductTypeDTO.nullish(),
        promotion: ProductDetailPromotionDTO,
        isRedDot: z.boolean().nullish(),
        masterId: z.string().nullish(),
        hasAudio: z.boolean().default(false),
        defaultVariantId: z.string().nullish(),
        socialProof: z.string().nullish(),
    })
    .and(BrandDTO)
    .and(PriceDTO);

const ProductDetailDTO = z
    .object({
        banners: z.array(ProductDetailBannerDTO).default([]),
        variants: z.array(ProductDetailVariantDTO).default([]),
        medias: z.array(MediaDTO).default([]),
        flags: z.array(FlagDTO).default([]),
        breadcrumbs: z.array(BreadcrumbDTO).default([]),
    })
    .and(ProductDetailBaseDTO);

export type ProductDetailDTO = z.infer<typeof ProductDetailDTO>;

export const ProductDetailContainerDTO = z.object({
    product: ProductDetailDTO,
});

export type ProductDetailContainerDTO = z.infer<typeof ProductDetailContainerDTO>;

export const ProductDetailWithUnknownDTO = z.object({
    product: z
        .object({
            banners: DecoderHelpers.defaultArray(z.unknown()),
            variants: DecoderHelpers.defaultArray(z.unknown()),
            medias: DecoderHelpers.defaultArray(z.unknown()),
            flags: DecoderHelpers.defaultArray(z.unknown()),
            breadcrumbs: DecoderHelpers.defaultArray(z.unknown()),
        })
        .and(ProductDetailBaseDTO),
});
